import { useEffect, useState } from 'react';

import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { color } from '../../styles/GlobalStyles';
import { getDashboardInfo } from './Dashboard.actions';

import { Box, Flexed, SlideWrapper } from '../../styles/GlobalComponents';
import { DashboardNav } from './DashboardNav';

import Modal from 'react-modal';
import advertisementHub1 from '../../assets/images/backoffice/ad1.png';
import advertisementHub2 from '../../assets/images/backoffice/ad2.png';
import advertisementHub3 from '../../assets/images/backoffice/ad3.png';
import advertisementHub4 from '../../assets/images/backoffice/ad4.png';

import { H3, H4, P2 } from '../../styles/FontStyles';
import MigrationTermsPrivacy from '../MigrationTermsPrivacy/MigrationTermsPrivacy';

import firstWin from '../../assets/images/backoffice/dashboard/firstWin.png';
import futuraMining from '../../assets/images/backoffice/dashboard/futuraMining.png';
import futuraMiningMobile from '../../assets/images/backoffice/dashboard/futuraMiningMobile.png';
import joinCommunity from '../../assets/images/backoffice/dashboard/banner3.png';
import joinCommunityMobile from '../../assets/images/backoffice/dashboard/joinCommunityMobile.png';

import minara from '../../assets/images/backoffice/dashboard/banner4.png';
import minaraMobile from '../../assets/images/backoffice/dashboard/minaraMobile.png';
import firstWinMobile from '../../assets/images/backoffice/dashboard/firstWinMobile.png';
import theIgnitePlan from '../../assets/images/backoffice/dashboard/theIgnitePlan.png';
import theIgnitePlanMobile from '../../assets/images/backoffice/dashboard/theIgnitePlanMobile.png';

import unicaPay from '../../assets/images/backoffice/dashboard/unicaPay.png';
import unicaPayMobile from '../../assets/images/backoffice/dashboard/unicaPayMobile.png';

import {
  africanCountryCodes,
  isPartnerHelper
} from '../../helpers/helperFunctions';
import { getCurrentLicense } from '../../slices/auth-slice';
import SignUp from '../SignUp/SignUp';
import { EarningsComponent } from './EarningsComponent';

import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import topPerformerUnderlay from '../../assets/images/topPerformerBack.png';

import { getRanking } from '../Ranking/Ranking.actions';

import { Ranking } from '../Ranking/Ranking';
import { BannerText, BannerWrapper, BannerTextMobile } from './DashboardStyled';
import { Link } from 'react-router-dom';
import {
  ENTRY_PACKAGE,
  MY_HUBS_FUTURA_MINING,
  MY_HUBS_MINARA,
  SETTINGS_VIRTUAL_OFFICE
} from '../../routes/routes';

import 'swiper/css';
import 'swiper/css/navigation';

import { JourneyToSuccess } from './JourneyToSuccess';

export enum UserType {
  CUSTOMER = 1,
  PARTNER
}

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const [termsConditionsModal, setTermsConditionsModal] = useState(false);
  const [userTypeModal, setUserTypeModal] = useState(false);

  const [userType, setUserType] = useState(UserType.CUSTOMER);
  const { dashboardInfo, loading } = useAppSelector((state) => state.dashboard);

  const user = userInfo.user;

  const isPartner = isPartnerHelper(
    dashboardInfo?.user?.currentVirtualOfficeLicence?.dateEnd || ''
  );

  const { ranking, loading: rankingLoading } = useAppSelector(
    (state) => state.ranking
  );

  const africanCountryCode = africanCountryCodes.find(
    (item) => item === user?.countryCode
  );

  const dashboardBanners = [
    { image: unicaPay, overlay: false },
    ...(africanCountryCode
      ? [
          {
            image: theIgnitePlan,
            link: ENTRY_PACKAGE,
            overlay: false
          }
        ]
      : []),

    { image: futuraMining, link: ENTRY_PACKAGE, overlay: false },
    { image: joinCommunity, link: MY_HUBS_FUTURA_MINING, overlay: true },
    { image: minara, link: MY_HUBS_MINARA, overlay: false }
  ];

  const dashboardBannersMobile = [
    { image: unicaPayMobile, overlay: false },
    ...(africanCountryCode
      ? [
          {
            image: theIgnitePlanMobile,
            link: ENTRY_PACKAGE,
            overlay: false
          }
        ]
      : []),

    { image: futuraMiningMobile, link: ENTRY_PACKAGE, overlay: false },
    { image: joinCommunityMobile, link: MY_HUBS_FUTURA_MINING, overlay: true },
    { image: minaraMobile, link: MY_HUBS_MINARA, overlay: false }
  ];

  useEffect(() => {
    if (!userInfo.isFirstLoginPopupChecked) {
      dispatch(getCurrentLicense());
      setUserTypeModal(true);
    } else if (!userInfo.isMavieMigrationModalChecked) {
      dispatch(getCurrentLicense());
      setTermsConditionsModal(true);
    }
    dispatch(getDashboardInfo());
    if (isPartner) {
      dispatch(getRanking());
    }
  }, [dispatch, userInfo.isMavieMigrationModalChecked, isPartner]);

  const [totalRewards, setTotalRewards] = useState<number | null>(null);

  useEffect(() => {
    const fetchRewards = async () => {
      try {
        const res = await fetch(
          'https://mining-api.futura-mining.com/api/statistics/'
        );
        const data = await res.json();
        setTotalRewards(data?.total_rewards ?? null);
      } catch (e) {
        setTotalRewards(null);
      }
    };
    fetchRewards();
  }, []);

  if (loading || (rankingLoading && !dashboardInfo))
    return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <Flexed gap='20px' rowSM width='100%'>
        {!isPartner && (
          <Flexed width='30%' widthSM='100%'>
            <Box
              style={{ width: '100%', marginBottom: 0 }}
              p='46px 36px'
              pSM='46px 36px'
              mSM='0'
              mbSM='0'>
              <DashboardNav user={user} />
            </Box>
          </Flexed>
        )}
        <Flexed
          column
          width={isPartner ? '100%' : '70%'}
          widthSM='100%'
          gap='20px'>
          <Desktop>
            <Flexed>
              <SlideWrapper width='100%' margin='0'>
                <Swiper
                  slidesPerView={1.05}
                  modules={[Navigation]}
                  navigation={true}
                  spaceBetween={10}
                  loop={true}>
                  {dashboardBanners.map((item, index) => {
                    const content = (
                      <BannerWrapper>
                        <img src={item.image} alt={`banner-${index + 1}`} />
                        {item.overlay && (
                          <BannerText>
                            Be part of the{' '}
                            <span>
                              {totalRewards !== null
                                ? Number(totalRewards).toFixed(5)
                                : '—'}{' '}
                              BTC
                            </span>{' '}
                            already mined through the Futura dashboard. Start
                            mining your Bitcoin today.
                          </BannerText>
                        )}
                      </BannerWrapper>
                    );

                    return (
                      <SwiperSlide key={index}>
                        {item.link ? (
                          <Link to={item.link} style={{ display: 'block' }}>
                            {content}
                          </Link>
                        ) : (
                          content
                        )}
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </SlideWrapper>
            </Flexed>
          </Desktop>
          <Mobile>
            <Flexed>
              <SlideWrapper width='100%' margin='0'>
                <Swiper
                  slidesPerView={1}
                  modules={[Navigation]}
                  navigation={true}
                  spaceBetween={10}
                  loop={true}>
                  {dashboardBannersMobile.map((item, index) => {
                    const content = (
                      <BannerWrapper>
                        <img src={item.image} alt={`banner-${index + 1}`} />
                        {item.overlay && (
                          <BannerTextMobile>
                            Be part of the{' '}
                            <span>
                              {totalRewards !== null
                                ? Number(totalRewards).toFixed(5)
                                : '—'}{' '}
                              BTC
                            </span>{' '}
                            already mined through the Futura dashboard. Start
                            mining your Bitcoin today.
                          </BannerTextMobile>
                        )}
                      </BannerWrapper>
                    );

                    return (
                      <SwiperSlide key={index}>
                        {item.link ? (
                          <Link to={item.link} style={{ display: 'block' }}>
                            {content}
                          </Link>
                        ) : (
                          content
                        )}
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </SlideWrapper>
            </Flexed>
          </Mobile>
          {isPartner && (
            <Flexed gap='20px' rowSM width='100%'>
              <Flexed column width='45%' widthSM='100%' gap='20px'>
                {isPartner && (
                  <div style={{ width: '100%' }}>
                    <EarningsComponent user={user} backOffice={dashboardInfo} />
                  </div>
                )}
                {isPartner && ranking && ranking.length > 0 && (
                  <Ranking ranking={ranking} isDashboard={true} />
                )}
                <Box
                  relative
                  overflow='hidden'
                  m='0'
                  style={{ marginBottom: 0 }}>
                  <H4
                    fontFamily='Nulshock'
                    caps
                    color={color.colors.primary900}
                    mb='20'>
                    Advertisement hub
                  </H4>

                  <SlideWrapper width='calc(100% + 25px)' margin='0'>
                    <Swiper
                      slidesPerView={1.2}
                      modules={[Navigation, Autoplay]}
                      navigation={true}
                      spaceBetween={10}
                      loop={true}
                      autoplay={{ delay: 4000, disableOnInteraction: false }}>
                      <SwiperSlide>
                        <a
                          href='https://futura-mining.com/'
                          target='_blank'
                          rel='noreferrer'>
                          <img
                            src={advertisementHub1}
                            alt='advertisement hub 1'
                            style={{ width: '100%' }}
                          />
                        </a>
                      </SwiperSlide>
                      <SwiperSlide>
                        <a
                          href='https://www.unicapay.com/'
                          target='_blank'
                          rel='noreferrer'>
                          <img
                            src={advertisementHub2}
                            alt='advertisement hub 2'
                            style={{ width: '100%' }}
                          />
                        </a>
                      </SwiperSlide>
                      <SwiperSlide>
                        <a
                          href='https://lms.unitedone.global/login'
                          target='_blank'
                          rel='noreferrer'>
                          <img
                            src={advertisementHub3}
                            alt='advertisement hub 3'
                            style={{ width: '100%' }}
                          />
                        </a>
                      </SwiperSlide>
                      <SwiperSlide>
                        <a
                          href='https://minara.ai/home'
                          target='_blank'
                          rel='noreferrer'>
                          <img
                            src={advertisementHub4}
                            alt='advertisement hub 4'
                            style={{ width: '100%' }}
                          />
                        </a>
                      </SwiperSlide>
                    </Swiper>
                  </SlideWrapper>
                </Box>
              </Flexed>

              <Box
                relative
                overflow='hidden'
                m='0'
                style={{ marginBottom: 0 }}
                bg={`url(${topPerformerUnderlay})`}
                bgSize='cover'
                bgPosition='center'
                bgRepeat='no-repeat'>
                <JourneyToSuccess ranking={ranking} />
              </Box>
            </Flexed>
          )}
          {!isPartner && (
            <Flexed gap='20px' rowSM width='100%'>
              <Flexed column width='50%' widthSM='100%'>
                <img
                  src={advertisementHub1}
                  alt='advertisement hub 1'
                  style={{ width: '100%' }}
                />
              </Flexed>
              <Flexed column width='50%' widthSM='100%'>
                <img
                  src={advertisementHub2}
                  alt='advertisement hub 2'
                  style={{ width: '100%' }}
                />
              </Flexed>
            </Flexed>
          )}
        </Flexed>
      </Flexed>

      <Modal
        isOpen={userTypeModal}
        contentLabel='Terms Conditions'
        className={'termsModalDashboard'}
        overlayClassName='myoverlay2'
        closeTimeoutMS={500}
        ariaHideApp={false}>
        <SignUp
          setUserTypeModal={setUserTypeModal}
          setTermsConditionsModal={setTermsConditionsModal}
          setUserType={setUserType}
        />
      </Modal>
      <Modal
        isOpen={termsConditionsModal}
        contentLabel='Terms Conditions'
        className={'termsModalDashboard'}
        overlayClassName='myoverlay2'
        closeTimeoutMS={500}
        ariaHideApp={false}>
        <MigrationTermsPrivacy
          setTermsConditionsModal={setTermsConditionsModal}
          isMavieMigrationModalChecked={userInfo?.isMavieMigrationModalChecked}
          userType={userType}
        />
      </Modal>
    </AnimatedDashboard>
  );
};

export default Dashboard;
